import { RECYCLING_COLOR } from 'constants/colors';
import { isRecyclingEvent } from 'constants/shipmentStatus';

// Define a mapping of event description text style
const DESCRIPTION_COLOR_MAP = [
  {
    match: isRecyclingEvent,
    style: { color: RECYCLING_COLOR },
  },
];

export const eventDescriptionStyle = (event) => {
  const matching = DESCRIPTION_COLOR_MAP.find((item) => item.match(event));

    return matching ? matching.style : undefined;
  };
